<template>
  <iframe
    :src="src"
    scrolling="no"
    frameborder="0"
    allowTransparency="true"
    seamless
    class="panorama-iframe"
  ></iframe>
</template>

<script>
export default {
  name: 'manage-vr',
  data() {
    return {
      src: process.env.VUE_APP_PANORAMA_URL
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.pano_no) {
      this.src += `?pano_no=${this.$route.query.pano_no}`
    } else if (this.$route.query && this.$route.query.id) {
      this.src += `?id=${this.$route.query.id}`
    }
  }
}
</script>
<style lang="scss" scoped>
.panorama-iframe {
  border: none;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  min-height: inherit;
  margin-bottom: -3px;
  height: 100vh;
}
</style>
